import { ApiResponse } from "@/interfaces/api-response";
import { ClipArt, UploadManyClipArts } from "@/interfaces/clip-art.interface";
import apiClient from "@/utils/axios";

const SERVICE_ENDPOINT = "clip-arts";

const getMany = async (params: {
  sort?: string;
  page?: number;
  size?: number;
  search?: string;
  categoryId?: string;
}) => {
  const response = await apiClient.get<ApiResponse<ClipArt[]>>(
    `/${SERVICE_ENDPOINT}`,
    {
      params,
    },
  );
  return response.data;
};

const getOneById = async (id: string, params?: object) => {
  const response = await apiClient.get<ApiResponse<ClipArt>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    { params },
  );
  return response.data;
};

const getOneByCategoryAndOption = async (
  categoryId: string,
  optionId: number,
) => {
  const response = await apiClient.get<ApiResponse<ClipArt | undefined>>(
    `/${SERVICE_ENDPOINT}/by-category-and-option`,
    { params: { categoryId, optionId } },
  );
  return response.data;
};

const updateOneById = async (
  id: string,
  data: Partial<ClipArt>,
  params?: object,
) => {
  const response = await apiClient.put<ApiResponse<ClipArt>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    data,
    { params },
  );
  return response.data;
};

const updateMany = async (clipArts: Partial<ClipArt>[]) => {
  const response = await apiClient.put<ApiResponse<ClipArt>>(
    `/${SERVICE_ENDPOINT}`,
    { items: clipArts },
  );
  return response.data;
};

const deleteOneById = async (id: string) => {
  const response = await apiClient.delete<ApiResponse<ClipArt>>(
    `/${SERVICE_ENDPOINT}/${id}`,
  );
  return response.data;
};

const uploadMany = async (payload: UploadManyClipArts) => {
  const response = await apiClient.post<ApiResponse<ClipArt>>(
    `/${SERVICE_ENDPOINT}/upload-many`,
    payload,
  );
  return response.data;
};

const clipArtApi = {
  getMany,
  getOneById,
  getOneByCategoryAndOption,
  updateOneById,
  updateMany,
  deleteOneById,
  uploadMany,
};

export default clipArtApi;
